import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductFreeDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (event.detail.resource) {
        // console.log('event', event.detail.resource)

        const price = event.detail.resource
    //   const variantSku = event.detail.resource.sku || '';

    //   if (variantSku) {
    //     // Show the component and update the SKU
    //     this.style.display = 'block';
    //     this.refs.sku.textContent = variantSku;
    //   } else {
    //     // Hide the entire component when SKU is empty
    //     this.style.display = 'none';
    //     this.refs.sku.textContent = '';
    //   }
    }

    const newInventory = event.detail.data.html.querySelector('product-free-delivery');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });

    // console.log('New inventory: ', newInventory)
  };
}

if (!customElements.get('product-free-delivery')) {
  customElements.define('product-free-delivery', ProductFreeDelivery);
}
